import ContactSkeleton from '@Components/General/Skeletons/contact-view';
import { createFileRoute } from '@tanstack/react-router';
import { contactQueryOptions } from '@utils/queryOptions';
import ContactDetails from '@Views/Contacts/Contacts/ContactDetails';

export const Route = createFileRoute('/contacts/$contactId_')({
    component: ContactDetails,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            contactQueryOptions(opts.params.contactId),
        ),
    pendingComponent: ContactSkeleton,
});
